import * as React from "react";
import { Objects } from "../../../../../../../react-core/Utils/Objects";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { DocumentTaskRequestTypeEnum } from "../../../../../../../Wrap/Constants/Enums/Tasks/DocumentTaskRequestTypeEnum";
import { EncryptedInstructionDocumentTypeRequest } from "../../../../../../../Wrap/Models/Models/Documents/InstructionDocuments/EncryptedInstructionDocumentTypeRequest";
import { ApplyModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { GiaContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/PersonalPortfolio/GiaContributionModel";
import { WrapCashContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/WrapCash/WrapCashContributionModel";
import { IsaContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/OneOffPayment/Isa/IsaContributionModel";
import { ContributionAndWithdrawalBase } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/ContributionAndWithdrawalBase";
import { MultiDownloadButton } from "../../../../../../Shared/DownloadButton/MultiDownloadButton";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { DocumentsHelper } from "../../../PortfolioDashboard/Components/Document/Resource/DocumentsHelper";
import { SubAccountTypeHelper } from "../../Helpers/SubAccountTypeHelper";
import { processTypeEnum } from "../../Resource/Contents";
import { SectionHeader } from "../../SharedComponents";
import { InstructionDocumentTypeRequestTriggerActionsCreator } from "../Actions/InstructionDocumentTypeRequestTriggerActionsCreator";
import { IllustrationType } from "../Resource/Content";
import { PensionBase } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/PensionBase";
import { InstructionStatus } from "../../../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";
import { ClientAccountStore } from "../../../../../Stroes/Variable";
import { SubAccount } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/SubAccount";

interface IIllustrationsProps extends IProcessComponentProps {
    data:
        | ApplyModel
        | GiaContributionModel
        | IsaContributionModel
        | PensionContributionModel
        | WrapCashContributionModel;
    processType: processTypeEnum;
    subAccountType: SubAccountType;
    needGoToDlu: boolean;
    selectAll: boolean;
    triggerred: number;
    clAccountId?: string;
 customerId?: number;
    hideCheckbox?: boolean;
}

interface IIllustrations {}

export class Illustrations extends ProcessComponent<IIllustrationsProps, IIllustrations> {
    constructor(props: IIllustrationsProps) {
        super(props);
        this.state = {};
    }
    private readonly _allowedProcesses: processTypeEnum[] = [processTypeEnum.PPToISA, processTypeEnum.PPToSIPP];

    private subClAccountIdForPPToProduct(): string {
        const clientAccount = ClientAccountStore.getClientAccountInfo();

        if(this.props.processType == processTypeEnum.PPToISA){
            return clientAccount?.SubAccounts?.find((subAccount: SubAccount) => subAccount.SubAccountType == SubAccountType.StocksIsa).ClAccountId;
        }

        if(this.props.processType == processTypeEnum.PPToSIPP){
            return clientAccount?.SubAccounts?.find((subAccount: SubAccount) => subAccount.SubAccountType == SubAccountType.Npr).ClAccountId;
        }
    }

    public render(): JSX.Element {
        const { processType } = this.props;
        const props = {
            triggerred: this.props.triggerred,
            isSelectedAll: this.props.selectAll,
        };
        const showIllustrations = this._allowedProcesses.includes(processType);
        if (!showIllustrations) {
            return <div></div>
        }

        const params = getQueryParameters();
        const subClAccountId = this.subClAccountIdForPPToProduct();
        const instructionId = params["id"];
        const headAccountHierarchyId = params["hierarchyid"];
        
        return ( showIllustrations &&
            <>
                {SectionHeader("Illustrations")}
                { processType == processTypeEnum.PPToISA && 
                <MultiDownloadButton
                    fileName="ISA Portfolio Illustration"
                    triggerAuto
                    {...props}
                    data={null}
                    onChange={() => {}}
                    onRef={(ref) => this.appendChild(ref)}
                    hideCheckbox={this.props.hideCheckbox}
                    request={DocumentsHelper.getTaskRequestForISAPortfolioIllustration(
                        HierarchyIdHelper.generateHierarchyId(instructionId).entityId,
                        subClAccountId,
                        DocumentTaskRequestTypeEnum.ISAPortfolioIllustration
                    )}
                    selectedAccount={headAccountHierarchyId}
                />
                }
                { processType == processTypeEnum.PPToSIPP && 
                    <MultiDownloadButton
                        fileName="Pre-Sales Pension Illustration"
                        triggerAuto
                        {...props}
                        data={null}
                        onChange={() => {}}
                        onRef={(ref) => this.appendChild(ref)}
                        hideCheckbox={this.props.hideCheckbox}
                        request={DocumentsHelper.getTaskRequestForPreSalePensionIllustration(
                            HierarchyIdHelper.generateHierarchyId(instructionId).entityId,
                            subClAccountId,
                            DocumentTaskRequestTypeEnum.PreSalePensionIllustration
                        )}
                        selectedAccount={headAccountHierarchyId}
                    />  
                }
                              
            </>
        );
    }
}